import { Tooltip, TooltipContent, TooltipTrigger } from "@istari-frontend/ui";
import type { LucideIcon } from "lucide-react";

import { cn } from "~/utils/cn";

export interface ChatAction {
  key: string;
  icon: LucideIcon;
  label: string;
  pressed: boolean;
  disabled?: boolean;
  onClick: () => void;
}

// Icon-only toggle group that floats over the conversation.
export function ChatActionGroup({ actions, className }: { actions: ChatAction[]; className?: string }) {
  return (
    <div
      role="group"
      aria-label="Conversation actions"
      className={cn(
        "border-border bg-background divide-border flex divide-x overflow-hidden rounded-lg border shadow-xs",
        className,
      )}
    >
      {actions.map((action) => (
        <Tooltip key={action.key}>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label={action.label}
              aria-pressed={action.pressed}
              disabled={action.disabled}
              onClick={action.onClick}
              className={cn(
                "focus-visible:ring-ring flex size-8 items-center justify-center transition-colors outline-none focus-visible:ring-1 focus-visible:ring-inset disabled:pointer-events-none disabled:opacity-50",
                action.pressed ? "bg-secondary-foreground text-secondary" : "text-foreground hover:bg-accent",
              )}
            >
              <action.icon className="size-4" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom">{action.label}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
